import { render, staticRenderFns } from "./processConfig.vue?vue&type=template&id=71e08ca6&scoped=true"
import script from "./processConfig.vue?vue&type=script&lang=js"
export * from "./processConfig.vue?vue&type=script&lang=js"
import style0 from "./processConfig.vue?vue&type=style&index=0&id=71e08ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e08ca6",
  null
  
)

export default component.exports